<template>
  <div>
    <div class="">
      <div class="component-title">
        <h1 class="">Loan Application Summary</h1>
      </div>

      <form action="">
        <div class="container w-100" style="max-width: 800px; font-size: 18px">

          <div class="loan-content-1 row flx align-items-center mb-20 mt-40">
            <div class="col-sm-5 col-md-5">Loan Amount Requested</div>
            <div class="col-sm-7 col-md-7 flx align-items-center">
              $<input type="type" id="loanamount" class="input-common-lg"/>
            </div>
          </div>

          <div class="loan-content-1 row flx mb-20 align-items-center">
            <div class="col-sm-5 col-md-5">Loan Repayment Frequency</div>
            <div class="col-sm-7 col-md-7 flx align-items-center">
              <div class="toggle">
                <label>
                  <input v-model="loan_frequency" type="radio" value="weekly" required=""/>
                  <div class="default">Weekly</div>
                </label>
                <label>
                  <input v-model="loan_frequency" type="radio" value="fortnightly" required=""/>
                  <div class="default">Fortnightly</div>
                </label>
                <label>
                  <input v-model="loan_frequency" type="radio" value="monthly" required=""/>
                  <div class="default">Monthly</div>
                </label>
              </div>
            </div>
          </div>

          <div class="loan-content-1 row flx align-items-center mb-20">
            <div class="col-sm-5 col-md-5">Loan Term</div>
            <div class="col-sm-7 col-md-7 flx align-items-center">
              <label class="default col-sm-3 pl-0" for="">
                <input type="text" class="input-common-lg" value="" required=""/>
              </label>
              <div class="toggle">
                <label>
                  <input v-model="loan_term" type="radio" value="months" required=""/>
                  <div class="default">Months</div>
                </label>
                <label>
                  <input v-model="loan_term" type="radio" value="years" required=""/>
                  <div class="default">Years</div>
                </label>
              </div>
            </div>
          </div>

          <div class="loan-content-1 row flx align-items-center mb-20">
            <div class="col-sm-5 col-md-5">Case Term</div>
            <div class="col-sm-7 col-md-7 flx align-items-center">
              <label class="default col-sm-3 pl-0" for="">
                <input type="text" class="input-common-lg" value="" required=""/>
              </label>
              <div class="toggle">
                <label>
                  <input v-model="case_term" type="radio" value="months" required=""/>
                  <div class="default">Months</div>
                </label>
                <label>
                  <input v-model="case_term" type="radio" value="years" required=""/>
                  <div class="default">Years</div>
                </label>
              </div>
            </div>
          </div>

          <div class="oan-content-1 row flx align-items-center mb-20">
            <div class="col-sm-5 col-md-5">Estimated Repayment</div>
            <div class="col-sm-7 col-md-7">
              $<span id="repayment_amount" style="color: green"></span> druing case
            </div>
            <input type="hidden" id="hidden_estimated_repayment"/>
          </div>

          <div class="oan-content-1 row flx align-items-center">
            <div class="col-sm-5 col-md-5">
              Estimated Repayment Insterest + Principal
            </div>
            <div class="col-sm-7 col-md-7">
              $<span id="repayment_amount" style="color: green"></span>
            </div>
            <input type="hidden" id="hidden_estimated_repayment"/>
          </div>
          <!-- END Loan Amount -->

          <div class="pl-20 pr-20">
            <table class="loan_information" id="sacc_loan" style="margin-top:50px;">
              <colgroup>
                <col span="1" style="width: 70%;">
                <col span="1" style="width: 30%;">
              </colgroup>
              <tbody>
                <tr>
                  <td colspan="2"><strong>Loan fees and charges</strong></td>
                </tr>
                <tr>
                  <td>Establishment Fee<br>Payable once off per loan</td>
                  <td class="second_column">$400</td>
                </tr>
                <tr>
                  <td>Interest Rate<br>This is the annual percentage rate. Interest accrues daily, and is charged monthly in arrears- on the outstanding balance of your loan</td>
                  <td class="second_column">47% of principle per annum</td>
                </tr>
                <tr>
                  <td>Comparison Rate<br>This comparison rate is based on an unsecured loan for an amount of $2,500 over 2 years and a $400 establishment fee</td>
                  <td class="second_column">63.22% of principle per annum</td>
                </tr>
                <tr>
                  <td colspan="2"><p class="ml-40 mr-40">WARNING: This comparison rate is true only for the example fiven and amy not include all fees and charges. Different terms, fees or other loan amounts</p></td>
                </tr>
                <tr>
                  <td colspan="2"><strong>Fees that may apply</strong></td>
                </tr>
                <tr>
                  <td>
                    Dishonour Fee<br>
                    Charged each time a direct debit or other payment is not made
                    in full or on time. This fee includes any reasonable internal and
                    administrative costs and external third party costs.
                  </td>
                  <td class="second_column">$20</td>
                </tr>
                <tr>
                  <td>
                    Reschedule Fee<br>
                    Reschdedule fee to cover reasonable costs of adminstering your account while your account remains in default.
                  </td>
                  <td class="second_column">$20</td>
                </tr>
              </tbody>
            </table>
          </div>
          <!-- END Table -->

          <div class="reason-list pt-40 toggle-container">
            <label>
              <input class="" v-model="loan_type" type="radio" value="Vehicle"/>
              <div class="reason-item reason-item-1 pointer">
                  <span class="ps-reason-item-msg">Vehicle <br> Expense</span>
              </div>
            </label>
            <label>
              <input class="" v-model="loan_type" type="radio" value="Travel"/>
              <div class="reason-item reason-item-2 pointer">
                  <span class="ps-reason-item-msg">Travel</span>
              </div>
            </label>
            <label>
              <input class="" v-model="loan_type" type="radio" value="Home"/>
              <div class="reason-item reason-item-3 pointer">
                  <span class="ps-reason-item-msg">Home/Rent<br> Upgrades</span>
              </div>
            </label>
            <label>
              <input class="" v-model="loan_type" type="radio" value="Medical"/>
              <div class="reason-item reason-item-4 pointer">
                  <span class="ps-reason-item-msg">Medical <br> Expenses</span>
              </div>
            </label>
            <label>
              <input class="" v-model="loan_type" type="radio" value="Education"/>
              <div class="reason-item reason-item-5 pointer">
                  <span class="ps-reason-item-msg">Education <br>Expense</span>
              </div>
            </label>
            <label>
              <input class="" v-model="loan_type" type="radio" value="Purchases"/>
              <div class="reason-item reason-item-6 pointer">
                  <span class="ps-reason-item-msg">Purchases</span>
              </div>
            </label>
            <label>
              <input class="" v-model="loan_type" type="radio" value="Bills"/>
              <div class="reason-item reason-item-7 pointer">
                  <span class="ps-reason-item-msg">Bills</span>
              </div>
            </label>
            <label>
              <input class="" v-model="loan_type" type="radio" value="Other"/>
              <div class="reason-item reason-item-8 pointer">
                  <span class="ps-reason-item-msg">Other</span>
              </div>
            </label>
          </div>

          <div class="mt-40">
            <p class="text-right">Can you Foresee any reason you won't be able to repay this loan?</p>
            <div class="">
              <div class="col-sm-5 col-md-5 flx align-items-center float-right justify-content-end">
                <div class="toggle">
                  <label>
                    <input v-model="is_repay" type="radio" value="yes"/>
                    <div class="default" for="">Yes</div>
                  </label>
                  <label>
                    <input v-model="is_repay" type="radio" value="no"/>
                    <div class="default" for="">No</div>
                  </label>
                </div>
              </div>
            </div>
          </div>
          <div class="clear"></div>
          <!-- END Loan Term -->

          <div class="pt-20 row Introduce-yourself-container mt-20">
            
            <div class="row"> 
              <div class="col-sm-4 col-md-4">
                  <span>First Name</span>
                  <input type="text" class="">
              </div>
              <div class="col-sm-4 col-md-4">
                  <span>Middle Name</span>
                  <input type="text" class="">
              </div>
              <div class="col-sm-4 col-md-4">
                  <span>Last Name</span>
                  <input type="text" class="">
              </div>
            </div>

            <div class="row pt-10">
              <div class="col-sm-4 col-md-4">
                  <span>Date of birth</span>
                  <div class="ps-relative">
                    <input type="date" class="">
                  </div>
              </div>
              <div class="col-sm-6 col-md-6">
                  <span>Email address</span>
                  <input type="text" id="emailname" class="" readonly>
              </div>
            </div>

            <div class="row pt-10"> 
              <div class="col-sm-4 col-md-4">
                  <span>Mobile Number</span>
                  <input type="text" class="" readonly>
              </div>
              <div class="col-sm-4 col-md-4">
                  <span>Home Phone Number</span>
                  <input type="text" class="">
              </div>
            </div>

            <div class="pt-10">
              <p>Are you an Australian Citizen or Permanent Resident?</p>
              <div class="toggle">
                <label>
                  <input v-model="is_au_pr" type="radio" value="yes"/>
                  <div class="default" for="">Yes</div>
                </label>
                <label>
                  <input v-model="is_au_pr" type="radio" value="no"/>
                  <div class="default" for="">No</div>
                </label>
              </div>
            </div>

            <div class="row pt-10">
              <div class="col-sm-12 col-md-4">
                  <span>Medicare Card Number</span>
                  <input type="text" class="">
              </div>
              <div class="col-sm-8 col-md-4">
                  <span>Reference Number</span>
                  <input type="text" class="">
              </div>
              <div class="col-sm-4 col-md-4">
                  <span>Card Colour</span>
                  <select id="medicare_card_colour" required>
                      <option selected="selected" value="">Please Specify</option>
                      <option value="G">Green</option>
                      <option value="B">Blue</option>
                      <option value="Y">Yellow</option>
                  </select>
              </div>
            </div>

            <div class="row pt-10">
              <div class="col-sm-12 col-md-4">
                  <span>Medicare Middle Name</span>
                  <input type="text" class="" autofocus="">
              </div>
              <div class="col-sm-8 col-md-4">
                  <span>Valid To Date</span>
                  <input id="medicare_valid_date" class="form-control" required="required" data-inputmask="'alias': 'date'" type="text" value="" im-insert="false">
              </div>
            </div>

          </div>
          <!-- END Introduce Yourself -->

          <div class="account-list row mt-20">
            <div class="col-md-4">
              <p class="account-1-msg">Fund Distribution to this account</p>
              <div class="account-item account-item-1 ps-relative">
                <div class="account-icon"></div>
                <select id="select-account-bank-1" class="account-item-input" required>
                    <option value="1" selected='selected'>1</option>
                </select>
                <p class="account-item-bank-number"></p>
              </div>
              <p class="account-2-msg mx-auto text-center">Primary Account</p>
              <input type="hidden" id="first_account_number">
              <input type="hidden" id="first_bsb_number">
              <input type="hidden" id="first_account_name">
              <input type="hidden" id="first_bank_name">
            </div>
            <div class="col-md-4">
              <p class="account-1-msg visibility-hide">Fund Distribution to this account</p>
              <div class="account-item other-account-item account-item-2 ps-relative">
                <div class="account-icon"></div>
                <select id="select-account-bank-2" class="account-item-input" required>
                    <!-- <option selected="selected" value="">Select</option> -->
                    <option selected="selected" value="2">2</option>
                    <option value="3">3</option>
                </select>
                <p class="account-item-bank-number">
                </p>
                <input type="hidden" id="second_account_number">
                <input type="hidden" id="second_bsb_number">
                <input type="hidden" id="second_account_name">
                <input type="hidden" id="second_bank_name">
              </div>
              <p class="account-2-msg mx-auto text-center">Secondary Account</p>
            </div>
            <div class="col-md-4">
              <p class="account-1-msg visibility-hide">Fund Distribution to this account</p>
              <div class="account-item other-account-item account-item-3 ps-relative">
                <div class="account-icon"></div>
                <select id="select-account-bank-3" class="account-item-input" required>
                    <!-- <option selected="selected" value="">Select</option> -->
                    <option value="2">2</option>
                    <option value="3" selected="selected">3</option>
                </select>
                <p class="account-item-bank-number">
                </p>
                <input type="hidden" id="third_account_number">
                <input type="hidden" id="third_bsb_number">
                <input type="hidden" id="third_account_name">
                <input type="hidden" id="third_bank_name">
              </div>
              <p class="account-2-msg mx-auto text-center">Tertiary Account</p>
            </div>
          </div>
          <!-- END Repayment Account -->

          <div class="mt-20">
            <div class="row">
              <div class="col-sm-12 col-md-12">
                  <span>ID Verification</span>
                  <select id="id-verification2" required @change="switchVerifiation($event.target.value)">
                      <option value="passport-section" selected>Passport</option>
                      <option value="drivers-license">Drivers License</option>
                      <option value="birth-certificate">Birth Certificate</option>
                  </select>
              </div>
            </div>

            <div class="row pt-10 passport-section verification-option">
              <div class="col-sm-6 col-md-6 mt-10">
                  <span>Passport Number</span>
                  <input type="PassportNumber" id="PassportNumber" class="input-common-lg w-100">
              </div>
              <div class="col-sm-6 col-md-6 mt-10">
                  <span>Country</span>
                  <select id="PassportCountry" required>
                      <option value="usa" selected>USA</option>
                      <option value="aus">AUS</option>
                      <option value="uk">UK</option>
                  </select>
              </div>

              <div class="col-sm-6 col-md-6 mt-10">
                <span>Country of tax residence</span>
                <input type="CountryTax" id="CountryTax" class="input-common-lg w-100">
              </div>

              <div class="col-sm-6 col-md-6 mt-10">
                  <span>Citizenship of</span>
                  <select id="Citizenship" required>
                      <option value="usa" selected>USA</option>
                      <option value="aus">AUS</option>
                      <option value="uk">UK</option>
                  </select>
              </div>

              <div class="col-sm-6 col-md-6 mt-10">
                  <span>Residency status</span>
                  <select id="Residency" required>
                      <option value="usa" selected>USA</option>
                      <option value="aus">AUS</option>
                      <option value="uk">UK</option>
                  </select>
              </div>

              <div class="col-sm-6 col-md-6 mt-10">
                  <span>Country of birth</span>
                  <select id="CountryOfBirth" required>
                      <option value="usa" selected>USA</option>
                      <option value="aus">AUS</option>
                      <option value="uk">UK</option>
                  </select>
              </div>

              <div class="col-sm-6 col-md-6 mt-10">
                  <span>City of birth</span>
                  <select id="CityOfBirth" required>
                      <option value="usa" selected>USA</option>
                      <option value="aus">AUS</option>
                      <option value="uk">UK</option>
                  </select>
              </div>

              <div class="col-sm-12 mt-40">
                <label class="flx align-items-start">
                  <input type="checkbox">
                  <p class="mb-0 ml-10">
                    I confirm that I am authorised to provide the personal details pressented and 
                    I consent to my information being checked with the document issuer or official 
                    record holder via third party systems and services for the purpose of confirming my identity
                  </p>
                </label>
              </div>
            </div>
          </div>
          <!-- END Id Verification -->


          <div class="mt-40">
            <div v-for="residential in residentials" :key="residential.id">
  
              <div class="address-section">
                  <div class="address-container address-0">
  
                      <div class="row">
                      <div class="col-sm-12 col-md-12">
                          <div class="flx">
                              <span>Enter your current address</span>
                          </div>
                          <input class="search_address pac-target-input input-common-lg w-100" type="text" placeholder="Enter a location" autocomplete="off">
  
                      </div>
                      </div>
                      <!-- Can't find your address? Click here-->
                      <p class="pt-10">Can't find your address? 
                      <a style="color: green;cursor: pointer" onclick="$(this).closest('.address-container').find('.address-expand').toggleClass('none')">Click here</a>
                      </p>
  
                      <div class="none component-9-choose-address address-expand">
                          <!--Unit Number Street Number-->
                          <div class="row">
                              <div class="col-sm-6 col-md-6">
                                  <span>Unit Number</span>
                                  <input type="text" class="field form-control input-common-lg w-100">
                              </div>
                              <div class="col-sm-6 col-md-6">
                                  <span>Street Number</span>
                                  <input type="text" class="field form-control input-common-lg w-100" required>
                              </div>
                          </div>
                          <!--Street Name City/Suburb-->
                          <div class="row pt-10">
                              <div class="col-sm-6 col-md-6">
                                  <span>Street Name</span>
                                  <input type="text" class="field form-control input-common-lg w-100" required>
                              </div>
                              <div class="col-sm-6 col-md-6">
                                  <span>City/Suburb</span>
                                  <input type="text" class="field form-control input-common-lg w-100" required>
                              </div>
                          </div>
                          <!--State Postcode-->
                          <div class="row pt-10">
                              <div class="col-sm-6 col-md-6">
                                  <span>State</span>
                                  <input type="text" class="field form-control input-common-lg w-100" required>
                              </div>
                              <div class="col-sm-6 col-md-6">
                                  <span>Postcode</span>
                                  <input type="text" class="field form-control input-common-lg w-100" required>
                              </div>
                          </div>
                          <!--Country-->
                          <div class="row pt-10 mb-20">
                              <div class="col-sm-6 col-md-6">
                                  <span>Country</span>
                                  <input type="text" class="field form-control input-common-lg w-100" required>
                              </div>
                              <div class="col-sm-6 col-md-6">
                                  <span>How long have you been at this address?(month)</span>
                                  <input type="number" class="field form-control input-common-lg w-100" required>
                              </div>
                          </div>
                      </div>
  
                  </div>
  
              </div>
              <div class="clear"></div>
            </div>
          </div>
          <!-- END Residential -->

          <div class="mt-40">
            <div v-for="employment in employments" :key="employment.id">
              <div class="Introduce-yourself-container">
                <div class="row pt-10 employment-container">
                  <div class="col-sm-6 col-md-6">
                    <span>Employment Status</span>
                    <select class="employment_category" id="employment_category[0]">
                      <option selected="selected" value="">Select</option>
                      <option value="Part time">Part time</option>
                      <option value="Full time">Full time</option>
                      <option value="Casual">Casual</option>
                      <option value="Self Employed">Self Employed</option>
                      <option value="Government Benefits">Government Benefits</option>
                    </select>
                  </div>
                  <div class="col-sm-6 col-md-6">
                    <span>Company Name</span>
                    <input placeholder="Company name*" id="employer_name[0]" type="text" class="input-common-lg w-100" />
                  </div>
                </div>
  
                <div class="row pt-10">
                  <div class="col-sm-12 col-md-12">
                    <span>Company Address</span>
                    <input type="text" class="companyAddress input-common-lg w-100" id="companyAddress[0]" />
                  </div>
                </div>
  
                <p class="pt-10">
                  Can't find your address?
                  <span style="color: green; cursor: pointer" onclick="$(this).closest('.Introduce-yourself-container').find('.address-expand').toggleClass('none')">Click here</span>
                </p>
                <div class="address-expand none" id="company[0]">
                  <div id="hideOnGovernmentBenefit[0]">
                    <div class="row">
                      <div class="col-sm-6 col-md-6">
                        <span>Unit Number</span>
                        <input type="text" id="company_unit_number[0]" class="input-common-lg w-100" />
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Street Number</span>
                        <input type="text" id="company_street_number[0]" class="input-common-lg w-100" />
                      </div>
                    </div>
  
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Street Name</span>
                        <input type="text" id="company_route[0]" class="input-common-lg w-100" />
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>City/Suburb</span>
                        <input type="text" id="company_locality[0]" class="input-common-lg w-100" />
                      </div>
                    </div>
  
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>State</span>
                        <input type="text" id="company_administrative_area_level_1[0]" class="input-common-lg w-100" />
                      </div>
                      <div class="col-sm-6 col-md-6">
                        <span>Postcode</span>
                        <input type="text" id="company_postal_code[0]" class="input-common-lg w-100" />
                      </div>
                    </div>
                  </div>
  
                  <div id="displayOnGovernmentBenefit[0]">
                    <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                        <span>Country</span>
                        <input type="text" id="company_country[0]" class="input-common-lg w-100" />
                      </div>
                      <div class="col-sm-6 col-md-6 radio-container" style="padding-top: 5px">
                        <span style="white-space: nowrap">Are you Currently Employed by this Employer?</span>
                        <div class="toggle-container toggle">
                          <label class="form-check-label">
                            <input class="form-check-input currentEmployment input-common-lg w-100" type="radio" id="current_employment_yes[0]" value="0" v-model="employment.current" />
                            <div class="default">Yes</div>
                          </label>
                          <label class="form-check-label">
                            <input class="form-check-input currentEmployment input-common-lg w-100" type="radio" id="current_employment_no[0]" value="1" v-model="employment.current" />
                            <div class="default">No</div>
                          </label>
                        </div>
                      </div>
                    </div>
  
                    <div class="row pt-10 mb-20">
                      <div class="col-sm-6 col-md-6"></div>
                      <div class="col-sm-6 col-md-6 radio-container none">
                        <span style="white-space: nowrap">How long have you been in this employment?</span>
                        <div class="time_interval">
                          <div class="row">
                            <div class="col-md-6">
                              <input type="date" class="start_date" max="2022-08-20" id="start_date[0]" placeholder="Start date" />
                            </div>
                            <div class="col-md-6">
                              <input type="date" class="end_date none" max="2022-08-20" id="end_date[0]" placeholder="End date" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
                <div v-if="employment.id!=0" class="col-sm-12 flx pointer change-employment-btn mb-20" style="width: max-content" @click="removeItem(employments, employment.id)">
                  <div class="reduce-icon">-</div>
                  <div>Remove Employment</div>
                </div>
                <div class="clear"></div>
              </div>
            </div>

            <div class="flx pointer change-employment-btn pt-10 addEmploymentBtn" style="width: max-content" @click="addItem(employments)" >
              <div class="add-icon">+</div>
              <span>Add New Employment</span>
            </div> 
          </div>
          <!-- END Employments -->

          <div class="mt-40">
            <div class="row flx mb-20 align-items-center">
              <div class="col-sm-6 col-md-6">
                Loan Repayment Frequency
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input type="text" class="form-control input-common-lg">
                </div>
              </div>
              <div class="col-sm-6 col-md-6 flx align-items-end">
                <div class="toggle mt-20">
                  <label>
                    <input v-model="primary_income" type="radio" value="weekly" required=""/>
                    <div class="default">Weekly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="fortnightly" required=""/>
                    <div class="default">Fortnightly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="monthly" required=""/>
                    <div class="default">Monthly</div>
                  </label>
                </div>
              </div>
            </div>

            <div v-for="income in incomes" :key="income.id">
              <div class="row flx mb-20 align-items-center">
                <div class="col-sm-6 col-md-6">
                  Other Income
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text">$</span>
                    </div>
                    <input type="text" class="form-control input-common-lg">
                  </div>
                </div>
                <div class="col-sm-6 col-md-6 flx align-items-end">
                  <div class="toggle mt-20">
                    <label>
                      <input v-model="primary_income" type="radio" value="weekly" required=""/>
                      <div class="default">Weekly</div>
                    </label>
                    <label>
                      <input v-model="primary_income" type="radio" value="fortnightly" required=""/>
                      <div class="default">Fortnightly</div>
                    </label>
                    <label>
                      <input v-model="primary_income" type="radio" value="monthly" required=""/>
                      <div class="default">Monthly</div>
                    </label>
                  </div>
                </div>
              </div>

              <div v-if="income.id!=0" class="col-sm-12 flx pointer change-employment-btn mb-20" style="width: max-content" @click="removeItem(incomes, income.id)">
                <div class="reduce-icon">-</div>
                <div>Remove Income</div>
              </div>
              <div class="clear"></div>
            </div>
            <div class="flx pointer change-employment-btn pt-10 addEmploymentBtn" style="width: max-content" @click="addItem(incomes)" >
              <div class="add-icon">+</div>
              <span>Add New Security</span>
            </div> 

          </div>
          <!-- END Income -->

          <div class="mt-40">
            <div class="row flx mb-20 align-items-center">
              <div class="col-sm-6 col-md-6">
                Mortgage Rent
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input type="text" class="form-control input-common-lg">
                </div>
              </div>
              <div class="col-sm-6 col-md-6 flx align-items-end">
                <div class="toggle mt-20">
                  <label>
                    <input v-model="primary_income" type="radio" value="weekly" required=""/>
                    <div class="default">Weekly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="fortnightly" required=""/>
                    <div class="default">Fortnightly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="monthly" required=""/>
                    <div class="default">Monthly</div>
                  </label>
                </div>
              </div>
            </div>

            <div class="row flx mb-20 align-items-center">
              <div class="col-sm-6 col-md-6">
                Utilities Bills
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input type="text" class="form-control input-common-lg">
                </div>
              </div>
              <div class="col-sm-6 col-md-6 flx align-items-end">
                <div class="toggle mt-20">
                  <label>
                    <input v-model="primary_income" type="radio" value="weekly" required=""/>
                    <div class="default">Weekly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="fortnightly" required=""/>
                    <div class="default">Fortnightly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="monthly" required=""/>
                    <div class="default">Monthly</div>
                  </label>
                </div>
              </div>
            </div>

            <div class="row flx mb-20 align-items-center">
              <div class="col-sm-6 col-md-6">
                Household Bills
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input type="text" class="form-control input-common-lg">
                </div>
              </div>
              <div class="col-sm-6 col-md-6 flx align-items-end">
                <div class="toggle mt-20">
                  <label>
                    <input v-model="primary_income" type="radio" value="weekly" required=""/>
                    <div class="default">Weekly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="fortnightly" required=""/>
                    <div class="default">Fortnightly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="monthly" required=""/>
                    <div class="default">Monthly</div>
                  </label>
                </div>
              </div>
            </div>

            <div class="row flx mb-20 align-items-center">
              <div class="col-sm-6 col-md-6">
                Medical Bills
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input type="text" class="form-control input-common-lg">
                </div>
              </div>
              <div class="col-sm-6 col-md-6 flx align-items-end">
                <div class="toggle mt-20">
                  <label>
                    <input v-model="primary_income" type="radio" value="weekly" required=""/>
                    <div class="default">Weekly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="fortnightly" required=""/>
                    <div class="default">Fortnightly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="monthly" required=""/>
                    <div class="default">Monthly</div>
                  </label>
                </div>
              </div>
            </div>

            <div class="row flx mb-20 align-items-center">
              <div class="col-sm-6 col-md-6">
                Insurance Bills
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input type="text" class="form-control input-common-lg">
                </div>
              </div>
              <div class="col-sm-6 col-md-6 flx align-items-end">
                <div class="toggle mt-20">
                  <label>
                    <input v-model="primary_income" type="radio" value="weekly" required=""/>
                    <div class="default">Weekly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="fortnightly" required=""/>
                    <div class="default">Fortnightly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="monthly" required=""/>
                    <div class="default">Monthly</div>
                  </label>
                </div>
              </div>
            </div>

            <div class="row flx mb-20 align-items-center">
              <div class="col-sm-6 col-md-6">
                Entertainment
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input type="text" class="form-control input-common-lg">
                </div>
              </div>
              <div class="col-sm-6 col-md-6 flx align-items-end">
                <div class="toggle mt-20">
                  <label>
                    <input v-model="primary_income" type="radio" value="weekly" required=""/>
                    <div class="default">Weekly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="fortnightly" required=""/>
                    <div class="default">Fortnightly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="monthly" required=""/>
                    <div class="default">Monthly</div>
                  </label>
                </div>
              </div>
            </div>

            <div class="row flx mb-20 align-items-center">
              <div class="col-sm-6 col-md-6">
                Phone/Interent Bill
                <div class="input-group">
                  <div class="input-group-prepend">
                    <span class="input-group-text">$</span>
                  </div>
                  <input type="text" class="form-control input-common-lg">
                </div>
              </div>
              <div class="col-sm-6 col-md-6 flx align-items-end">
                <div class="toggle mt-20">
                  <label>
                    <input v-model="primary_income" type="radio" value="weekly" required=""/>
                    <div class="default">Weekly</div>
                  </label>  
                  <label>
                    <input v-model="primary_income" type="radio" value="fortnightly" required=""/>
                    <div class="default">Fortnightly</div>
                  </label>
                  <label>
                    <input v-model="primary_income" type="radio" value="monthly" required=""/>
                    <div class="default">Monthly</div>
                  </label>
                </div>
              </div>
            </div>

          </div>
          <!-- END Expends -->

          <div class="mt-40">
            <div class="row"> 
              <div class="col-sm-6 col-md-6">
                  <span>Marital Status</span>
                  <select required>
                    <option selected="selected" value="">Please Specify</option>
                    <option value="Married">Married</option>
                    <option value="Single">Single</option>
                    <option value="Divorce">Divorce</option>
                  </select>
              </div>
              <div class="col-sm-6 col-md-6">
                  <span>Number of Dependants</span>
                  <select required>
                    <option selected="selected" value="">Please Specify</option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
              </div>
            </div>

            <div class="row mt-10"> 
              <div class="col-sm-6 col-md-6">
                  <span>How many children do you have?</span>
                  <select required v-model="childs">
                    <option selected="selected" value="">Please Specify</option>
                    <option value="0">0</option>
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                  </select>
              </div>
              <div class="col-sm-6 col-md-6">
                  <span>Please enter your children's ages:</span>
                  <div v-if="childs > 0">                    
                    <div class="col-sm-6 p-0" v-for="n in parseInt(childs) || 0" :key="n" :class="{'mt-10': n > 2,}" >
                      <input type="text" :placeholder="'Child '+n" class="input-common-lg w-100">
                    </div>
                  </div>
              </div>
            </div>

            <div class="row flx align-items-center  mt-10">
              <div class="col-sm-6 col-md-6">Are you the sole income earner in the household</div>
              <div class="col-sm-6 col-md-6 flx align-items-center">
                <div class="toggle">
                  <label>
                    <input v-model="sole_income" type="radio" value="Yes" required=""/>
                    <div class="default">Yes</div>
                  </label>
                  <label>
                    <input v-model="sole_income" type="radio" value="No" required=""/>
                    <div class="default">No</div>
                  </label>
                </div>
              </div>
            </div>

            <div class="row flx align-items-center  mt-10">
              <div class="col-sm-6 col-md-6">Would you be able to maintain your commitments & lifestyle if you or your partner were unable to earn an income?</div>
              <div class="col-sm-6 col-md-6 flx align-items-center">
                <div class="toggle">
                  <label>
                    <input v-model="commitments" type="radio" value="Yes" required=""/>
                    <div class="default">Yes</div>
                  </label>
                  <label>
                    <input v-model="commitments" type="radio" value="No" required=""/>
                    <div class="default">No</div>
                  </label>
                </div>
              </div>
            </div>

            <div class="row flx align-items-center  mt-10">
              <div class="col-sm-6 col-md-6">Do you have a will?</div>
              <div class="col-sm-6 col-md-6 flx align-items-center">
                <div class="toggle">
                  <label>
                    <input v-model="have_will" type="radio" value="Yes" required=""/>
                    <div class="default">Yes</div>
                  </label>
                  <label>
                    <input v-model="have_will" type="radio" value="No" required=""/>
                    <div class="default">No</div>
                  </label>
                </div>
              </div>
            </div>

            <div class="row flx align-items-center  mt-10">
              <div class="col-sm-6 col-md-6">Do you have adequate insurance to meet your loan repayments in the event you are unable to work? (e.g. life insurance, loan protection insurance, income protection insurance)</div>
              <div class="col-sm-6 col-md-6 flx align-items-center">
                <div class="toggle">
                  <label>
                    <input v-model="insurance" type="radio" value="Yes" required=""/>
                    <div class="default">Yes</div>
                  </label>
                  <label>
                    <input v-model="insurance" type="radio" value="No" required=""/>
                    <div class="default">No</div>
                  </label>
                </div>
              </div>
            </div>

            <p class="mt-20"><b>Next of Kin Details</b></p>


            <div class="row flx align-items-center  mt-10">
              <div class="col-sm-4">
                <span>First Name</span>
                <input type="text" class="input-common-lg w-100"/>
              </div>
              <div class="col-sm-4">
                <span>Middle Name</span>
                <input type="text" class="input-common-lg w-100"/>
              </div>
              <div class="col-sm-4">
                <span>Last Name</span>
                <input type="text" class="input-common-lg w-100"/>
              </div>
            </div>

            <div class="row flx align-items-center  mt-10">
              <div class="col-sm-4">
                <span>Mobile Name</span>
                <input type="text" class="input-common-lg w-100"/>
              </div>
              <div class="col-sm-6">
                <span>Next ok Kin Relationship</span>
                <select required>
                    <option selected="selected" value="">Please Specify</option>
                    <option value="Father">Father</option>
                    <option value="Monther">Monther</option>
                    <option value="Brother">Brother</option>
                    <option value="Sister">Sister</option>
                  </select>
              </div>
            </div>

          </div>
          <!-- END Yourself -->

          <div class="mt-40 row">
            <div v-for="asset in assets" :key="asset.id">
              <div class="assets-container mb-20">
                <div class="col-sm-6 col-md-6">
                  <span>Asset Type</span>
                  <select v-model="asset.selected">
                    <option value="" disabled>Select Property</option>
                    <option v-for="(option, index) in options.assets" :key="index" v-bind:value="option.value">{{ option.label }}</option>
                  </select>
                </div>

                <div class="assets-content">

                  <div v-if="asset.selected == 'Owner occipier property' || asset.selected == 'Investment property address'">
                    <div class="col-sm-6 col-md-6 float-right">
                      <span>Property Type</span>
                      <select>
                        <option selected="selected" value="">Select</option>
                      </select>
                    </div>
                    <div class="clear"></div>

                    <div class="address-container mt-10 pl-15 pr-15">

                      <div class="row pt-10">
                        <div class="col-sm-12 col-md-12">
                          <span>Enter your current address</span>
                          <input type="text" class="input-common-lg w-100" />
                        </div>
                      </div>

                      <p class="pt-10">
                        Can't find your address?
                        <span style="color: green; cursor: pointer" onclick="$(this).closest('.address-container').find('.address-expand').toggleClass('none')">Click here</span>
                      </p>

                      <div class="address-expand none">
                        <div>
                          <div class="row">
                            <div class="col-sm-6 col-md-6">
                              <span>Unit Number</span>
                              <input type="text" class="input-common-lg w-100" />
                            </div>
                            <div class="col-sm-6 col-md-6">
                              <span>Street Number</span>
                              <input type="text" class="input-common-lg w-100" />
                            </div>
                          </div>

                          <div class="row pt-10">
                            <div class="col-sm-6 col-md-6">
                              <span>Street Name</span>
                              <input type="text" class="input-common-lg w-100" />
                            </div>
                            <div class="col-sm-6 col-md-6">
                              <span>City/Suburb</span>
                              <input type="text" class="input-common-lg w-100" />
                            </div>
                          </div>

                          <div class="row pt-10">
                            <div class="col-sm-6 col-md-6">
                              <span>State</span>
                              <input type="text" class="input-common-lg w-100" />
                            </div>
                            <div class="col-sm-6 col-md-6">
                              <span>Postcode</span>
                              <input type="text" class="input-common-lg w-100" />
                            </div>
                          </div>
                        </div>

                        <div>
                          <div class="row pt-10">
                            <div class="col-sm-6 col-md-6">
                              <span>Country</span>
                              <input type="text" class="input-common-lg w-100" />
                            </div>
                            <div class="col-sm-6 col-md-6">
                              <span>Zoning</span>
                              <select>
                                <option selected="selected" value="">Select</option>
                                <option value="Commercial">Commercial</option>
                                <option value="Residential">Residential</option>
                                <option value="Industrial">Industrial</option>
                                <option value="Rural">Rural</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div>
                          <div class="row pt-10">
                            <div class="col-sm-6 col-md-6">
                              <span>Ownership %</span>
                              <input type="text" class="input-common-lg w-100" />
                            </div>
                            <div class="col-sm-6 col-md-6 pt-10 pb-10">
                              <p>
                                <label>
                                  <input type="checkbox" class=""> To be sold?
                                </label>
                              </p>
                              <p>
                                <label for="">
                                  <input type="checkbox" class=""> Will become Investment after settlement?
                                </label>
                              </p>
                            </div>
                          </div>
                        </div>

                      </div>

                    </div>

                  </div>
                  <!-- END property opt -->

                  <div v-if="asset.selected == 'Vehicle make and model'">
                    <div class="col-sm-6 col-md-6 float-right">
                      <span>Vehicle Type</span>
                      <select required="">
                        <option selected="selected" value="">Select</option>
                      </select>
                    </div>
                    <div class="clear"></div>
                    
                    <div class="mt-10 pl-15 pr-15">
                      <div class="row pt-10">
                        <div class="col-sm-12 col-md-12">
                          <span>Enter Vehicle Make and Model</span>
                          <input type="text" class="input-common-lg w-100"/>
                        </div>
                      </div>
                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Estimated Compliance Date</span>
                          <input type="date" class="input-common-lg w-100"/>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- END Vehicle opt -->

                  <div v-if="asset.selected == 'Bank Account'">
                    <div class="col-sm-6 col-md-6 float-right">
                      <span>Account Type</span>
                      <select required="">
                        <option selected="selected" value="">Select</option>
                        <option value="Savings">Savings</option>
                        <option value="Cheque">Cheque</option>
                        <option value="Transaction">Transaction</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div class="clear"></div>
                    
                    <div class="mt-10 pl-15 pr-15">
                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Bank Name</span>
                          <input type="text" class="input-common-lg w-100" />
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Bank Account Name</span>
                          <input type="text" class="input-common-lg w-100" />
                        </div>
                      </div>
                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Account BSB</span>
                          <input type="text" class="input-common-lg w-100" />
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Account Number</span>
                          <input type="text" class="input-common-lg w-100" />
                        </div>
                      </div>
                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Value</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Ownership</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">%</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- END Bank opt -->

                  <div v-if="asset.selected == 'Home contents' || asset.selected == 'Shares' || asset.selected == 'Other'">
                    <div class="col-sm-6 col-md-6 float-right">
                      <span>{{asset.selected}}</span>
                      <input class="input-common-lg w-100" type="text"/>
                    </div>
                    <div class="clear"></div>
                    
                    <div class="mt-10 pl-15 pr-15">
                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Value</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Ownership</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">%</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- END Home | Shares | Other opt -->

                  <div v-if="asset.selected == 'Super fund institution'">
                    <div class="col-sm-6 col-md-6 float-right">
                      <span>{{asset.selected}}</span>
                      <input class="input-common-lg w-100" type="text"/>
                    </div>
                    <div class="clear"></div>
                    
                    <div class="mt-10 pl-15 pr-15">
                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Membership Number</span>
                          <input type="text" class="input-common-lg w-100">
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Ownership</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">%</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                      </div>
                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Value</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- END Super fund opt -->

                </div>

                <div class="clear"></div>

                <div v-if="asset.id!=0" class="flx pointer change-employment-btn pt-10" style="width: max-content" @click="removeItem(assets, asset.id)">
                  <div class="reduce-icon">-</div>
                  <div>Remove Asset</div>
                </div>

              </div>
            </div>

            <div class="clear">
              <div class="flx pointer change-employment-btn pt-10 addEmploymentBtn col-sm-12" style="width: max-content" @click="addItem(assets)" >
                <div class="add-icon">+</div>
                <span>Add New Asset</span>
              </div> 
            </div>

          </div>
          <!-- END Asset -->

          <div class="mt-40 row">
            <div v-for="liability in liabilities" :key="liability.id">
              <div class="liabilities-container mb-20">
                <div class="col-sm-6 col-md-6">
                  <span>Liabilities Type</span>
                  <select v-model="liability.selected">
                    <option value="" disabled>Select Liabilities</option>
                    <option v-for="(option, index) in options.liabilities" :key="index" v-bind:value="option.value">{{ option.label }}</option>
                  </select>
                </div>

                <div class="liabilities-content">

                  <div v-if="liability.selected == 'Mortgage Loan'">
                    <div class="col-sm-6 col-md-6 float-right">
                      <span>Mortgage Type</span>
                      <select>
                        <option selected="selected" value="" disabled>Select</option>
                        <option value="Owner occupied">Owner occupied</option>
                        <option value="Investment">Investment</option>
                      </select>
                    </div>
                    <div class="clear"></div>

                    <div class="mt-10 pl-15 pr-15">
                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Lender</span>
                          <input type="text" class="input-common-lg w-100"/>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Loan Term Expiry Date</span>
                          <input type="date" class="input-common-lg w-100"/>
                        </div>
                      </div>

                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Repayment Type</span>
                          <select>
                            <option selected="selected" value="" disabled>Select</option>
                            <option value="Principal & interest">Principal & interest</option>
                            <option value="Interest only">Interest only</option>
                          </select>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Interest Rate</span>
                          <div class="input-group">
                            <input type="text" class="form-control input-common-lg">
                            <div class="input-group-append">
                              <span class="input-group-text">%</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row pt-10">
                        <div class="col-sm-12 col-md-12">
                          <span>Link Asset</span>
                          <select>
                            <option selected="selected" value="" disabled>Select</option>
                          </select>
                        </div>
                      </div>

                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>BSB</span>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Account Number</span>
                          <input type="text" class="form-control input-common-lg">
                        </div>
                      </div>

                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Limit</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Balance</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                      </div>

                      <div class="row pt-10 flx align-items-center">
                        <div class="col-sm-6 col-md-6">
                          <span>Ownership %</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">%</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-6 d-flex flex-column jutify-content-center">
                          <label>
                            <input type="checkbox" class=""> Refinance
                          </label>
                        </div>
                      </div>

                    </div>

                  </div>
                  <!-- END Mortgage Loan opt -->

                  <div v-if="liability.selected == 'Credit Card'">
                    <div class="col-sm-6 col-md-6 float-right">
                      <span>Credit Card Type</span>
                      <select required="">
                        <option selected="selected" value="" disabled>Select</option>
                        <option value="VISA">VISA</option>
                        <option value="Mastercard">Mastercard</option>
                        <option value="AMEX">AMEX</option>
                        <option value="Store Card">Store Card</option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                    <div class="clear"></div>
                    
                    <div class="mt-10 pl-15 pr-15">

                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Lender</span>
                          <input type="text" class="input-common-lg w-100"/>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Maximum Card Limit</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                      </div>

                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Balance</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Interest Rate</span>
                          <div class="input-group">
                            <input type="text" class="form-control input-common-lg">
                            <div class="input-group-append">
                              <span class="input-group-text">%</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Ownership %</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">%</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                  <!-- END Credit Card opt -->

                  <div v-if="liability.selected == 'Vehicle Loan'">
                    <div class="col-sm-6 col-md-6 float-right">
                      <span>Linked Asset</span>
                      <select required="">
                        <option selected="selected" value="" disabled>Select</option>
                      </select>
                    </div>
                    <div class="clear"></div>
                    
                    <div class="mt-10 pl-15 pr-15">
                      
                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Lender</span>
                          <input type="text" class="input-common-lg w-100"/>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Net Amount Financed</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                      </div>

                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Balance</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Interest Rate</span>
                          <div class="input-group">
                            <input type="text" class="form-control input-common-lg">
                            <div class="input-group-append">
                              <span class="input-group-text">%</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Ownership %</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">%</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Account/Loan Number</span>
                          <input type="text" class="w-100 input-common-lg">
                        </div>
                      </div>

                    </div>

                  </div>
                  <!-- END Vehicle Loan opt -->

                  <div v-if="liability.selected == 'Personal Loan'">
                    <div class="col-sm-6 col-md-6 float-right">
                      <span>Account/Loan Number</span>
                      <input class="input-common-lg w-100" type="text"/>
                    </div>
                    <div class="clear"></div>
                    
                    <div class="mt-10 pl-15 pr-15">
                      
                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Lender</span>
                          <input type="text" class="input-common-lg w-100"/>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Net Amount Funanced</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                      </div>

                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Balance</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Interest Rate</span>
                          <div class="input-group">
                            <input type="text" class="form-control input-common-lg">
                            <div class="input-group-append">
                              <span class="input-group-text">%</span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Ownership %</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">%</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                  <!-- END Personal Loan opt -->

                  <div v-if="liability.selected == 'Student Loan' || liability.selected == 'Other' || liability.selected == 'Balance Sheet'">
                    <div class="col-sm-6 col-md-6 float-right">
                      <span>Account/Loan Number</span>
                      <input class="input-common-lg w-100" type="text"/>
                    </div>
                    <div class="clear"></div>
                    
                    <div class="mt-10 pl-15 pr-15">
                      
                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Lender</span>
                          <input type="text" class="input-common-lg w-100"/>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Net Amount Funanced</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                      </div>

                      <div class="row pt-10">
                        <div class="col-sm-6 col-md-6">
                          <span>Balance</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">$</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                        <div class="col-sm-6 col-md-6">
                          <span>Ownership %</span>
                          <div class="input-group">
                            <div class="input-group-prepend">
                              <span class="input-group-text">%</span>
                            </div>
                            <input type="text" class="form-control input-common-lg">
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                  <!-- END Super fund opt -->

                </div>

                <div class="clear"></div>

                <div v-if="liability.id!=0" class="flx pointer change-employment-btn pt-10" style="width: max-content" @click="removeItem(liabilities, liability.id)">
                  <div class="reduce-icon">-</div>
                  <div>Remove Liability</div>
                </div>

              </div>
            </div>

            <div class="clear">
              <div class="flx col-sm-12 pointer change-employment-btn pt-10 addEmploymentBtn" style="width: max-content" @click="addItem(liabilities)" >
                <div class="add-icon">+</div>
                <span>Add New Liability</span>
              </div> 
            </div>
          </div>
          <!-- END Liability -->

          <div class="mt-40">
            <div class="address-section">
              <div class="address-container address-0">

                <div class="row">
                  <div class="col-sm-12 col-md-12">
                      <div class="flx">
                          <span>Enter your post settlement address</span>
                      </div>
                      <input class="search_address pac-target-input input-common-lg w-100" type="text" placeholder="Enter a location" autocomplete="off">

                  </div>
                </div>
                <!-- Can't find your address? Click here-->
                <p class="pt-10">Can't find your address? 
                  <a style="color: green;cursor: pointer" onclick="$(this).closest('.address-container').find('.address-expand').toggleClass('none')">Click here</a>
                </p>

                <div class="none component-9-choose-address address-expand row">
                  <!--Unit Number Street Number-->
                  <div class="row">
                      <div class="col-sm-6 col-md-6">
                          <span>Unit Number</span>
                          <input type="text" class="field form-control input-common-lg w-100">
                      </div>
                      <div class="col-sm-6 col-md-6">
                          <span>Street Number</span>
                          <input type="text" class="field form-control input-common-lg w-100" required>
                      </div>
                  </div>
                  <!--Street Name City/Suburb-->
                  <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                          <span>Street Name</span>
                          <input type="text" class="field form-control input-common-lg w-100" required>
                      </div>
                      <div class="col-sm-6 col-md-6">
                          <span>City/Suburb</span>
                          <input type="text" class="field form-control input-common-lg w-100" required>
                      </div>
                  </div>
                  <!--State Postcode-->
                  <div class="row pt-10">
                      <div class="col-sm-6 col-md-6">
                          <span>State</span>
                          <input type="text" class="field form-control input-common-lg w-100" required>
                      </div>
                      <div class="col-sm-6 col-md-6">
                          <span>Postcode</span>
                          <input type="text" class="field form-control input-common-lg w-100" required>
                      </div>
                  </div>
                  <!--Country-->
                  <div class="row pt-10 mb-20">
                      <div class="col-sm-6 col-md-6">
                          <span>Country</span>
                          <input type="text" class="field form-control input-common-lg w-100" required>
                      </div>
                      <div class="col-sm-6 col-md-6">
                          <span>How long have you been at this address?(month)</span>
                          <input type="number" class="field form-control input-common-lg w-100" required>
                      </div>
                  </div>
                </div>

              </div>

            </div>

            <div class="mt-40">
              <p class="text-center">Are there any specific services that you require assistance with?<br>Select any of the services listed below and we will arrage for someone to contact you</br></p>
              <div>
                <ul class="nav mx-auto" style="max-width: 500px">
                  <li>
                    <label class="fw-normal">
                      <input type="checkbox" class="mr-10" value="Insurance and asset protection">
                      <span>Insurance and asset protection</span>
                    </label>
                  </li>
                  <li>
                    <label class="fw-normal">
                      <input type="checkbox" class="mr-10" value="Investement, superannuation and financial planning">
                      <span>Investement, superannuation and financial planning</span>
                    </label>
                  </li>
                  <li>
                    <label class="fw-normal">
                      <input type="checkbox" class="mr-10" value="Property buying advocacy">
                      <span>Property buying advocacy</span>
                    </label>
                  </li>
                  <li>
                    <label class="fw-normal">
                      <input type="checkbox" class="mr-10" value="Estate planning">
                      <span>Estate planning</span>
                    </label>
                  </li>
                  <li>
                    <label class="fw-normal">
                      <input type="checkbox" class="mr-10" value="Property investment">
                      <span>Property investment</span>
                    </label>
                  </li>
                  <li>
                    <label class="fw-normal">
                      <input type="checkbox" class="mr-10" value="Conveyancing">
                      <span>Conveyancing</span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>            
          </div>
          <!-- END Post settlement -->

          <div class="mt-40">
            <p>
              This guide does not constitute legal advice. We encourage you to seek your own prefessional advice to find out
              how the Corporations Act and other applicatble laws apply to you, as it is your responsibility to determine your obligations.
              Please speak to your financial advisor, lawyer or visi <a href="https://www.moneysmart.com.au">www.moneysmart.com.au</a>
              before marking a decision.
            </p>
            <p>
              More Information: For general financial information and calculators please visit www.moneysmart.com.au or visit our website
              <a href="https://www.ccfunding.com.au">www.ccfunding.com.au</a>
            </p>

            <p class="mt-20">Declaration</p>
            <ul class="nav">
              <li>
                <label class="fw-normal flx align-items-start">
                  <input type="checkbox" value="I declare that the information I have provided">
                  <p class="ml-10">I declare that the information I have provided in my application on {{new Date().toDateString()}} is true and accurate.</p>
                </label>
              </li>
              <li>
                <label class="fw-normal flx align-items-start">
                  <input type="checkbox" value="I would like to hear more about promotions and offers">
                  <p class="ml-10">I would like to hear more about promotions and offers that Capital & Centric Funding that may interest me.</p>
                </label>
              </li>
              <li>
                <label class="fw-normal flx align-items-start">
                  <input type="checkbox" value="I agree to the Terms and Conditions">
                  <p class="ml-10">I agree to the Terms and Conditions of <span class="text-green">Capital & Centric Funding's Direct Debit Request and Service Agreement.</span></p>
                </label>
              </li>
              <li>
                <label class="fw-normal flx align-items-start">
                  <input type="checkbox" value="I have reviewed the Privacy Policy">
                  <p class="ml-10">I have reviewed the <span class="text-green">Privacy Policy</span> and I understand and accept all terms they set out</p>
                </label>
              </li>
              <li>
                <label class="fw-normal flx align-items-start">
                  <input type="checkbox" value="I have read and understood the Acknowledgement and Consent">
                  <p class="ml-10">
                    I have read and understood the <span class="text-green">Acknowledgement and Consent</span> and make all consent and
                    acknowledgement it contains, including consenting to: an electronic identity verification, promotion of products
                    and services, information exchange with other providers and a credit check.
                  </p>
                </label>
              </li>
            </ul>

            <p class="mt-20">Document to Download before submitting - Click <a class="text-green">Here</a> to download all documents</p>
            <div>
              <div class="b5-row download-list">
                <div class="download-item b5-col-3">
                  <a href="https://mps.ccfunding.com.au/downloadPdf/PrivacyStatement.pdf" style="text-decoration:none;pointer:cursor;color:black">
                    <div class="file-download-duotone-icon file-download-duotone-1-icon download-item-icon"></div>
                    <p class="download-item-name">Privacy Consent</p>
                  </a>
                </div>

                <div class="download-item b5-col-3">
                  <a href="https://mps.ccfunding.com.au/downloadPdf/Acknowledgment.pdf" style="text-decoration:none;pointer:cursor;color:black">
                    <div class="file-download-duotone-icon file-download-duotone-3-icon download-item-icon"></div>
                    <p class="download-item-name">Acknowledgement and Consent</p>
                  </a>
                </div>
                <div class="download-item b5-col-3">
                  <a href="https://mps.ccfunding.com.au/downloadPdf/Things%20you%20should%20know%20about%20your%20Credit%20Contract.pdf" style="text-decoration:none;pointer:cursor;color:black">
                    <div class="file-download-duotone-icon file-download-duotone-4-icon download-item-icon"></div>
                    <p class="download-item-name">Things you need to know about your credit contract</p>
                  </a>
                </div>
                <div class="download-item b5-col-3">
                  <a href="https://mps.ccfunding.com.au/downloadPdf/Capital%20&amp;%20Centric%20Funding%20Credit%20Guide.pdf" style="text-decoration:none;pointer:cursor;color:black">
                    <div class="file-download-duotone-icon file-download-duotone-5-icon download-item-icon"></div>
                    <p class="download-item-name">Credit Guide</p>
                  </a>
                </div>
                <div class="download-item b5-col-3">
                  <a href="https://mps.ccfunding.com.au/downloadPdf/PrivacyStatement.pdf" style="text-decoration:none;pointer:cursor;color:black">
                    <div class="file-download-duotone-icon file-download-duotone-1-icon download-item-icon"></div>
                    <p class="download-item-name">Key Fact Sheet Consent</p>
                  </a>
                </div>

                <div class="download-item b5-col-3">
                  <a href="https://mps.ccfunding.com.au/downloadPdf/Acknowledgment.pdf" style="text-decoration:none;pointer:cursor;color:black">
                    <div class="file-download-duotone-icon file-download-duotone-3-icon download-item-icon"></div>
                    <p class="download-item-name">Terms of the Loan</p>
                  </a>
                </div>
                <div class="download-item b5-col-3">
                  <a href="https://mps.ccfunding.com.au/downloadPdf/Things%20you%20should%20know%20about%20your%20Credit%20Contract.pdf" style="text-decoration:none;pointer:cursor;color:black">
                    <div class="file-download-duotone-icon file-download-duotone-4-icon download-item-icon"></div>
                    <p class="download-item-name">Memorandum of Common Provisions (Mortgage)</p>
                  </a>
                </div>
                <div class="download-item b5-col-3">
                  <a href="https://mps.ccfunding.com.au/downloadPdf/Capital%20&amp;%20Centric%20Funding%20Credit%20Guide.pdf" style="text-decoration:none;pointer:cursor;color:black">
                    <div class="file-download-duotone-icon file-download-duotone-5-icon download-item-icon"></div>
                    <p class="download-item-name">Booklet of Terms</p>
                  </a>
                </div>
              </div>
            </div>

            <div>
              <p class="mt-20">Legal</p>
              <label class="fw-normal flx align-items-start">
                <input type="checkbox" value="I acknowledge that a person who commits">
                <article class="ml-10">
                  <p>
                    I acknowledge that a person who commits a fraud by deception or
                    dishonesty or makes a false document with the intention that a
                    person or entity or another party will use it to induce some person
                    or entity or another party to accept it as genuine, and because of
                    its being accepted as genuine obtain any property belonging to
                    another, or to obtain any financial advantage or cause any financial
                    disadvantage, or to influence the exercise of a public duty, is
                    guilty of the criminal offence and such a person will be referred to
                    the relevant law enforcement authority and criminally prosecuted.
                  </p>
                  <p>
                    Pursuant to the Oaths Act 1900 (NSW) I, do hereby solemnly swear, 
                    declare and affirm, that all the information provided by me in my 
                    application to Capital & Centric Funding Pty Ltd is truthful, 
                    correct and accurate – according to the law in this behalf made – 
                    and subject to the punishment by law provided for any wilfully false 
                    statement or information within this application.
                  </p>
                </article>
              </label>
              <p class="mt-20">Jurisdiction</p>
              <label class="fw-normal flx align-items-start">
                <input type="checkbox" value="I acknowledge that a person who commits">
                <article class="ml-10">
                  <p>
                    All parties to this agreement irrevocably agrees that the courts of 
                    New South Wales Australia shall have exclusive jurisdiction to hear, 
                    settle and/or determine any dispute, controversy or claim 
                    (including any non-contractual dispute, controversy or claim) 
                    arising out of or in connection with this agreement, including any 
                    question regarding its existence, validity, formation or termination. 
                    For these and all purposes, each party irrevocably submits to the 
                    jurisdiction of the New South Wales Courts, Australia.
                  </p>
                </article>
              </label>
            </div>
          </div>
          <!-- END Declare -->

        </div>
      </form>

    </div>
    
    <button type="button" style="margin: auto; display: block" class="continue-btn mt-50 mb-30 mt-10" @click.prevent.stop="onContinue('thank-you')">
      <a href="#" class="steps-btn" style="display: block; color: #fff">SUBMIT</a>
    </button>
    <div class="mt-60 clear"></div>
    
  </div>
</template>

<script>
export default {
  props: ["onChangeStep"],
  data(){
    return {
      loan_frequency: "",
      loan_term: "",
      case_term: "",
      is_repay: "",
      is_au_pr: "",
      loan_type: "",
      primary_income: "",
      childs: 0,
      sole_income: "",
      commitments: "",
      have_will: "",
      insurance: "",
      residentials: [{id:0},],
      employments: [{id:0, current: ""},],
      incomes: [{id: 0,},],
      assets: [{id: 0,},],
      liabilities: [{id: 0,},],
      options: {
        assets: [
          {value:"Owner occipier property",label:"Owner occipier property"},
          {value:"Investment property address",label:"Investment property address"},
          {value:"Vehicle make and model",label:"Vehicle make and model"},
          {value:"Bank Account",label:"Bank Account"},
          {value:"Home contents",label:"Home contents"},
          {value:"Shares",label:"Shares"},
          {value:"Other",label:"Other"},
          {value:"Super fund institution",label:"Super fund institution"},],
        liabilities: [
          {value:"Mortgage Loan",label:"Mortgage Loan"},
          {value:"Credit Card",label:"Credit Card"},
          {value:"Vehicle Loan",label:"Vehicle Loan"},
          {value:"Personal Loan",label:"Personal Loan"},
          {value:"Student Loan",label:"Student Loan"},
          {value:"Other",label:"Other"},
          {value:"Balance Sheet",label:"Balance Sheet"},],
      }, 
    }
  },
  methods: {
    onContinue(step) {
      this.onChangeStep(step);
    },
    addItem(array){
      var new_id = 0;
      do{++new_id;}while(array.find(e => e.id === new_id));
      array.push({id: new_id});
    },
    removeItem(array, id){
      var index = array.map(object => object.id).indexOf(id);
      array.splice(index,1);
    },
  },
};
</script>
